import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { scmAuthApi, scmIntegrationsApi } from './apis';

export const apisModule = createFrontendModule({
  pluginId: 'app',
  extensions: [scmIntegrationsApi, scmAuthApi],
});
